

import {    
    FETCH_ASSET_TOTALS_REQUEST,
    FETCH_ASSET_TOTALS_SUCCESS,
    FETCH_ASSET_TOTALS_FAILURE,
} from '../actions';

const initialState = 
{
    isLoading: false,
    error: '',    
    totals: []
};

const deviceTotalsReducer = ((state = initialState, action) => {
    switch (action.type) {
        case FETCH_ASSET_TOTALS_REQUEST:            
            return { ...state, isLoading: true, error: '' };
            case FETCH_ASSET_TOTALS_SUCCESS:
                return { ...state, totals: action.payload, isLoading: false, error: '' };        
        case FETCH_ASSET_TOTALS_FAILURE:
            return { ...state, isLoading: false, error: action.payload };
        default:
            return state;
    }
});

export default deviceTotalsReducer;